import usePressPreview from "../../hooks/usePressPreview";

/**
 * The text of a sheet row: a tap raises the song's preview, holding it peeks (the preview
 * goes when the finger lifts). `onPreview` gets { held } to open and null to close.
 */
const PreviewRow = ({ title, sub, kicker, onPreview }) => {
  const press = usePressPreview({
    onTap: () => onPreview({ held: false }),
    onHold: (held) => onPreview(held ? { held: true } : null),
  });

  return (
    <button type="button" className="grow sheet-press" aria-label={`Preview ${title}`} {...press}>
      {kicker && <span className="kicker">{kicker}</span>}
      <span className="title">{title}</span>
      {sub && <span className="sub">{sub}</span>}
    </button>
  );
};

export default PreviewRow;
